export default[
    {
        path: 'search',
        name: 'search',
        meta: {
            title: {
                i18n: 'title.search'
            },
            require_auth: true
        },
        component: () => import('../../views/search/Search')
    },
]
